import React, {useState, useRef, useEffect} from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import "../../assets/scss/components/date-range-filter.scss";
import {CalendarIcon, ArrowDownBold} from "../../assets/icons/Icons"
import {useFilterContext} from "../../contexts/FilterContext";
import Overlay from "../Overlay";
import {useTranslation} from "react-i18next";
import frLocale from "date-fns/locale/fr"

const DateRangeFilter = ({className, defaultValue}) => {

    const { t } = useTranslation();

    const { name, filterValue, setFilterValue, updateURLParams } = useFilterContext();

    const [submitDisabled, setSubmitDisabled] = useState(true);
    const defaultRange = defaultValue
        ? [
            {
                startDate: new Date(defaultValue.split(' - ')[0]),
                endDate: new Date(defaultValue.split(' - ')[1]),
                key: 'selection'
            }
        ]
        : [
            {
                startDate: null,
                endDate: null,
                key: 'selection'
            }
        ];
    const [range, setRange] = useState(defaultRange);

    const input = useRef();
    const calender = useRef();
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);

    const toggleCalendar = (e) => {
        setIsCalendarOpen(prev => !prev);
    }

    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    }

    const calendarSubmit = (e) => {
        if(range[0]?.endDate && range[0]?.startDate){
            const displayDate = `${formatDate(range[0].startDate)}  -  ${formatDate(range[0].endDate)}`;
            const urlDate = `${formatDate(range[0].startDate)}-${formatDate(range[0].endDate)}`;
            setFilterValue(displayDate);
            updateURLParams(name, urlDate);
            toggleCalendar();
        }
    }

    const calendarClear = (e) => {
        setRange(defaultRange);
        setFilterValue('');
        updateURLParams(name, '');
        toggleCalendar();
    }

    useEffect(() => {
        if(range[0]?.endDate && range[0]?.startDate){
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [range]);

    useEffect(() => {
        if (calender.current) {
            if (isCalendarOpen) {
                calender.current.classList.add('open');
            } else {
                calender.current.classList.remove('open');
            }
        }
    }, [isCalendarOpen]);

    useEffect(() => {
        if(defaultValue){
            setRange(defaultRange);
            setFilterValue(defaultValue);
            updateURLParams(name, defaultValue);
        }
    }, [defaultValue]);

    return (
        <div className={`filter date-range-filter ${className ? className : ''}`}>
            <div className="input-with-icon input-with-icon-left input-with-icon-right" onClick={toggleCalendar} style={{cursor: 'pointer'}}>
                <div className="input-icon input-icon-left"><CalendarIcon/></div>
                <div className="input-icon input-icon-right"><ArrowDownBold/></div>
                <input ref={input} value={filterValue} type="text" name="date-range-filter" placeholder={t("Select dates")}  readOnly/>
                <div className="icon-end"></div>
            </div>
            <div className="date-range-filter-calendar" ref={calender}>
                <DateRange
                    editableDateInputs={false}
                    onChange={item => setRange([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={range}
                    locale={localStorage.getItem('language') === 'fr' ? frLocale : undefined}
                    startDatePlaceholder={t('Start date')}
                    endDatePlaceholder={t('End date')}
                />
                <div className="date-range-filter-calendar-footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <button
                                    className="btn btn-secondary btn-medium date-range-filter-calendar-clear"
                                    onClick={calendarClear}>{t("Clear")}
                            </button>
                        </div>
                        <div className="col-xs-6">
                            <div className="text-right">
                                <button disabled={submitDisabled}
                                        className="btn btn-primary btn-medium date-range-filter-calendar-submit"
                                        onClick={calendarSubmit}>{t("Apply")}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Overlay visible={isCalendarOpen} onClick={toggleCalendar} />
        </div>
    );
};

export default DateRangeFilter;
